import { useState } from "react";
import { HandHeart, Plus, Trash2 } from "lucide-react";
import { SlotList } from "./EventExtras";

const PRESETS = [["Scorekeeper", 2], ["Team parent", 1], ["Pitch counter", 1], ["Field prep", 2]];

const KINDS = [["game", "Games"], ["practice", "Practices"], ["other", "Events"]];

const Applies = ({ value, onChange, testId }) => (
  <div className="flex flex-wrap items-center gap-1" data-testid={testId}>
    <span className="ctl-label mr-1">Needed at</span>
    {KINDS.map(([k, l]) => {
      const on = value.includes(k);
      if (!onChange) return on ? <span key={k} className="applies-chip applies-chip-on">{l}</span> : null;
      return (
        <button type="button" key={k} data-testid={`${testId}-${k}`} aria-pressed={on} className={`applies-chip ${on ? "applies-chip-on" : ""}`}
          onClick={() => { const next = on ? value.filter((x) => x !== k) : [...value, k]; if (next.length) onChange(next); }}>{l}</button>
      );
    })}
  </div>
);

const RoleForm = ({ onAdd }) => {
  const [f, setF] = useState({ label: "", capacity: 1, description: "", applies_to: ["game"] });
  const submit = (e) => {
    e.preventDefault();
    onAdd({ ...f, capacity: Number(f.capacity) || 1 }).then(() => setF({ label: "", capacity: 1, description: "", applies_to: ["game"] }), () => {});
  };
  return (
    <form className="card space-y-2" onSubmit={submit} data-testid="volunteer-role-form">
      <div className="flex flex-wrap gap-2">
        {PRESETS.map(([l, c]) => (
          <button type="button" key={l} className="btn-ghost !min-h-[40px] !text-sm" data-testid={`role-preset-${l.toLowerCase().replace(/\s+/g, "-")}`}
            onClick={() => setF({ ...f, label: l, capacity: c })}><Plus size={16} /> {l}</button>
        ))}
      </div>
      <div className="flex gap-2">
        <input data-testid="role-label-input" className="field-input flex-1 min-w-0" required maxLength={40} placeholder="Role, e.g. Scorekeeper" value={f.label} onChange={(e) => setF({ ...f, label: e.target.value })} />
        <input data-testid="role-capacity-input" type="number" min={1} max={10} className="field-input w-20" aria-label="Spots" value={f.capacity} onChange={(e) => setF({ ...f, capacity: e.target.value })} />
      </div>
      <input data-testid="role-description-input" className="field-input w-full" maxLength={200} placeholder="What's involved (optional)" value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} />
      <Applies value={f.applies_to} onChange={(applies_to) => setF({ ...f, applies_to })} testId="role-form-applies" />
      <button className="btn-primary w-full" data-testid="role-add-button">Add volunteer role</button>
    </form>
  );
};

export const VolunteerSection = ({ roles, me, onSign, onCancel, onAdd, onDelete, onRemove, onToggle }) => (
  <section className="space-y-3" data-testid="volunteer-section">
    <h2 className="font-heading text-3xl font-extrabold uppercase flex items-center gap-2"><HandHeart size={28} /> Season volunteers</h2>
    {onAdd && <RoleForm onAdd={onAdd} />}
    {roles.length === 0 ? (
      <div className="card font-semibold" data-testid="volunteers-empty">{onAdd ? "No roles yet. Add jobs like scorekeeper or team parent." : "No volunteer jobs posted yet."}</div>
    ) : (
      <div className="card">
        <SlotList slots={roles} me={me} onSign={onSign} onCancel={onCancel} onRemove={onRemove} title="Parent jobs for the whole season" testId="volunteer-list"
          detail={(r) => <Applies value={r.applies_to} onChange={onToggle && ((v) => onToggle(r, v))} testId="role-applies" />}
          extra={onDelete && ((r) => (
            <button className="icon-btn !min-h-[40px] !min-w-[40px]" aria-label="Delete role" data-testid="role-delete-button" onClick={() => onDelete(r)}><Trash2 size={16} /></button>
          ))} />
      </div>
    )}
  </section>
);
